import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => (
  <footer className="sunset-footer">
    <Container>
      <p className="sunset-footer-legal">&copy; {new Date().getFullYear()} YAS DIGITAL LIMITED</p>
    </Container>
  </footer>
);

export default Footer;
